import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=00e55996&"
import script from "./NotificationList.vue?vue&type=script&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports